import React, { useState } from 'react';
import { 
  FiClock, FiTrendingUp, FiCheckCircle, FiXCircle, FiTruck,
  FiInfo
} from 'react-icons/fi';
import { workOrderService, STATUS_FLOW } from '../services/workOrderService';

const StatusBadge = ({ status, size = 'sm', showIcon = true, workOrderId = null }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [history, setHistory] = useState([]);

  //Ambil dari STATUS_FLOW yang sudah terdefinisi di workOrderService
  const statusConfig = STATUS_FLOW?.[status] || null;
  
  //Fallback jika status tidak ditemukan
  const Icon = statusConfig?.icon 
    ? (() => {
        const iconMap = {
          'FiClock': FiClock,
          'FiTrendingUp': FiTrendingUp,
          'FiCheckCircle': FiCheckCircle,
          'FiXCircle': FiXCircle,
          'FiTruck': FiTruck
        };
        return iconMap[statusConfig.icon] || FiClock;
      })()
    : FiClock;
    
  const color = statusConfig?.color || 'bg-gray-100 text-gray-800';
  const label = statusConfig?.label || status;

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm',
    lg: 'px-4 py-1.5 text-base'
  };

  const handleMouseEnter = async () => {
    if (workOrderId) {
      try {
        const historyData = await workOrderService.getHistory(workOrderId);
        setHistory(historyData || []);
        setShowTooltip(true);
      } catch (error) {
        console.error('Error loading history:', error);
      }
    }
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleString('id-ID', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div 
      className="relative inline-block"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span className={`inline-flex items-center space-x-1 font-medium rounded-full ${color} ${sizeClasses[size]}`}>
        {showIcon && <Icon size={size === 'sm' ? 12 : size === 'md' ? 16 : 20} />}
        <span>{label}</span>
        {workOrderId && history.length > 0 && (
          <FiInfo size={size === 'sm' ? 10 : 14} className="ml-1 opacity-50" />
        )}
      </span>

      {/* Tooltip - Status History */}
      {showTooltip && workOrderId && history.length > 0 && (
        <div className="absolute bottom-full left-0 mb-2 w-72 bg-[var(--bg-primary)] rounded-lg shadow-lg border border-[var(--border-color)] p-3 z-50">
          <p className="text-xs font-semibold text-[var(--text-primary)] mb-2">Status History</p>
          <div className="space-y-2 max-h-40 overflow-y-auto">
            {history.slice().reverse().map((item, index) => (
              <div key={item.id || index} className="text-xs">
                <div className="flex items-center justify-between">
                  <span className="text-[var(--text-secondary)]">
                    {item.fromLabel} → {item.toLabel}
                  </span>
                  <span className="text-[var(--text-secondary)] font-medium">
                    {formatDate(item.timestamp)}
                  </span>
                </div>
                {item.note && (
                  <p className="text-[var(--text-secondary)] mt-0.5 italic">"{item.note}"</p>
                )}
                <p className="text-[var(--text-secondary)] text-[10px]">
                  by: {item.changedBy || 'System'}
                </p>
                {index < history.length - 1 && (
                  <div className="border-b border-[var(--border-color)] my-1"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusBadge;